import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Popper, TextField, Tooltip } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import './Assignee.css';
import { createFilterOptions } from '@material-ui/lab';
import { updatePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';

const filterSugguestionAssignOption = createFilterOptions({
    matchFrom: 'any',
    stringify: option => option.fullName
});

const handleKeyDown = (e, assigneeUserData) => {
    if (assigneeUserData && assigneeUserData.length > 0 && assigneeUserData[0]?.id !== Constant.OPTION_UNASSIGNEE.KEY) {
        e.preventDefault()
    }
}

const createNewItem = data => {
    let newItem = {
        id: data.id,
        fullName: data.assigneeFullName,
        avatar: data.avatar,
        lastName: { jp: { A: 'F', text: data.lastName } }
    };
    return newItem;
};

const RenderOptionTag = ({ params, assigneeUserData }) => {
    let newParams = { ...params };

    // newParams.inputProps.value = '';
    return (
        <TextField
            {...newParams}
            className="form-control form-control--wrapSelect form-control--hg40"
            // placeholder={Utils.isEmptyArray(assigneeUserData) ? '検索キーワード' : ''}
            variant="outlined"
            onKeyDown={(e) => handleKeyDown(e, assigneeUserData)}
        />
    );
};

const getShortFullName = (fullName,maxLength) => {
    if (fullName && fullName.length > maxLength) {
        fullName = fullName.substring(0, maxLength) + '...';
    }
    return fullName;
}

const AssigneeUI = props => {
    const [assigneeUserData, setAssigneeUserData] = useState([]);
    const [hasAssignee, setHasAssignee] = useState(false);
    const [listAssignee, setListAssignee] = useState([]);
    const [open, setOpen] = useState(false);
    // const [isMe, setIsMe] = useState(false);
    const {isMe, setIsMe} = props;


    useEffect(()=>{
        return () => {
            // console.log('---- namnhdebug cleanup AssigneeUI');
            setAssigneeUserData([]);
            setHasAssignee(false);
            setListAssignee([]);
        }
    },[])

    useEffect(()=>{
        props?.setNewAssigneeData(assigneeUserData[0])
    },[assigneeUserData])

    const onSelectNewAssign = async(e) => {
        if (e[e.length - 1] != undefined) {
            if (Utils.isEmptyString(e[e.length - 1]?.id)) {
                return;
            }
        }
        if (Utils.isEmptyArray(e)) {
            return;
        }

        const newValue = Utils.isEmptyArray(e) ? [] : [e[e.length - 1]];
        if (newValue[0].fullName === Constant.OPTION_ASSIGNEE_ME) {
            setIsMe(true);
        } else {
            setIsMe(false)
        }

        setAssigneeUserData(newValue);
        await updatePanelInitData(props.panelId, props.tabId, props.panelInitData, props.setPanelInitData, 'assigneeUserData', newValue);

        props.setIsEdited(true);
        if (props.setIsEditTicket) {
            props.setIsEditTicket(true);
        }
        if (typeof props?.setShowButtonEditTicket === 'function') props?.setShowButtonEditTicket();
        if(props?.setOnChangeEdit){
            props?.setOnChangeEdit(!props.onChangeEdit)
        }
    };

    const getAssigneeForCustomer = async data => {
        let itemInfo = { ...data };
        // if (itemInfo.avatar) {
        //     const avatarLink = await Storage.get(data.avatar);
        //     itemInfo.avatar = avatarLink;
        // }
        setListAssignee([createNewItem(itemInfo)]);
        setAssigneeUserData([{ ...createNewItem(itemInfo) }]);
    };

    const hasPermission = () => {
        if (props.isDisableEdit) return false;

        // At Guest Desk, all member has permission
        if (
            [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(props.corporationDetail?.contractType) &&
            props.selectedProject?.isDesk
        ) {
            return true;
        }

        let isAllow = (
            (props.isGeneralUser || props.isManager) &&
            props.isDisplayButtonEditTicket &&
            props.isHelpDesk
        );
        return isAllow
    };

    useEffect(() => {
        if (
            !Utils.isEmptyObject(assigneeUserData[0]) 
        ) {
            props.setNewAssignee(assigneeUserData[0]?.id);
            // props.setIsEdited(true);
        } else {
            props.setNewAssignee('');
        }
    }, [assigneeUserData]);

    useEffect(() => {
        if(props.currentPanelInitData && !Utils.isEmptyObject(props.currentPanelInitData)) {
            if (props.currentPanelInitData.assigneeUserData) {
                setAssigneeUserData(props.currentPanelInitData.assigneeUserData);
                setListAssignee([...props.assignList]);
                return;
            }
        }

        if (Utils.isEmptyObject(props.assigneeUserData)) {
            setAssigneeUserData([{
                id: Constant.OPTION_UNASSIGNEE.KEY,
                fullName: Constant.OPTION_UNASSIGNEE.TEXT
            }]);

            setListAssignee([...props.assignList]);
            return;
        }

        if (!Utils.isEmptyObject(props.assigneeUserData)) {
            if (props.isHelpDesk) {
                if (!Utils.isEmptyArray(props.assignList)) {
                    let selectedUser = props.assignList.find(user => {
                        return user.id === props.assigneeUserData.id;
                    });
                    
                    if (!selectedUser) {
                        selectedUser = { ...props.assigneeUserData }
                    }

                    setAssigneeUserData([{ ...selectedUser }]);
                    setListAssignee([...props.assignList]);
                } else {
                    getAssigneeForCustomer(props?.assigneeUserData);
                }
            } else {
                getAssigneeForCustomer(props?.assigneeUserData);
            }
            setHasAssignee(true);
        }
    }, [props.assigneeUserData, props.assignList]);

    useEffect(() => {
        if (!Utils.isEmptyObject(props.assigneeUserData) && !Utils.isEmptyArray(props.assignList)) {
            if (props.isHelpDesk) {
                const selectedUser = props.assignList.find(user => {
                    return user.id === props.assigneeUserData.id;
                });
                setListAssignee([...props.assignList]);
                setAssigneeUserData([{ ...selectedUser }]);
                props.setNewAssignee('');
            } else {
                getAssigneeForCustomer(props.assigneeUserData);
            }
        }
        props.setFlagReset(false);
    }, [props?.flagReset])

    let resultUser = listAssignee.filter(user => {
        return user.id === listAssignee[1]?.id;
    })

    const renderAssigneeName = (assigneeItem = {}) => {
        let name = assigneeItem?.fullName;
        if (!assigneeItem?.fullName) {
            name = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, assigneeItem);
        }

        if (assigneeItem?.fullName === Constant.OPTION_ASSIGNEE_ME && !isMe) {
            const user = resultUser[1];
            name = user?.fullName || Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, user);
        };

        if (Utils.isEmptyObject(assigneeItem) && !Utils.isEmptyObject(props?.assigneeUserData)) {
            name = props?.assigneeUserData?.fullName;
        }
        
        return getShortFullName(name, 35);
    };

    const getSelectedOptionAvatar = (currentSelectOption) => {
        let avatar = currentSelectOption?.avatar;
        let avatarShortName = currentSelectOption?.lastName ? Utils.getShortName(Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentSelectOption?.lastName)) : '';
        
        if ((!currentSelectOption || Utils.isEmptyObject(currentSelectOption)) && !Utils.isEmptyObject(props?.assigneeUserData)) {
            avatar = props?.assigneeUserData?.avatar || '';
            avatarShortName = props?.assigneeUserData?.assigneeIcon || props?.assigneeUserData?.shortName ? props?.assigneeUserData?.shortName : '';
        }
        if (currentSelectOption.fullName === Constant.OPTION_UNASSIGNEE.TEXT) {
            return <div></div>
        }

        if (avatar) {
            return (
                <img
                    src={avatar}
                    alt=""
                    className="assign-filter-avatar-autocomplete assign-filter-img avatar-tag-autocomplete"
                />
            )
        } else {
            return (
                <div className="assign-filter-icon-autocomplete assign-filter-img">
                    {avatarShortName}
                </div>
            )
        }
    }

    let getOptionSelect = (option, selectedValue) => {
        switch (option.fullName) {
            case Constant.OPTION_ASSIGNEE_ME:
                if (isMe) return isMe;
                return false
            case Constant.OPTION_UNASSIGNEE.TEXT:
                return option.id === selectedValue.id;
            default:
                if (isMe && option.id === listAssignee[1].id) return false;

                return option.id === selectedValue.id;
        }
    }

    let getTitle = (selectOption) => {
        switch (selectOption?.fullName) {
            case Constant.OPTION_ASSIGNEE_ME:
                return resultUser[1].fullName
            case Constant.OPTION_UNASSIGNEE.TEXT:
                return Constant.OPTION_UNASSIGNEE.TEXT;
            default:
                if (selectOption?.fullName || renderAssigneeName(selectOption)) {
                    return renderAssigneeName(selectOption);
                }
                return '';
        }
    }

    return (
        <div className={'form-addTicket'}>
            <div className="cell-prod-status gap-8">
                <label className="form-addTicket-label">
                    {'担当者'}
                </label>
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
            
            <div className="form-addTicket-input">
                <div
                    className={`assign-list-all ${
                        !hasPermission() ||
                        !Utils.isEmptyString(props.ticketDetail?.deletedAt) ||
                        props.ticketDetail?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED
                            ? 'class_disabled'
                            : ''
                    }`}
                >
                    <Autocomplete
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        key={`assignee-list-content-sugguest-${props.ticketDetail.id}`}
                        PopperComponent={({ style, ...popperProps }) => (
                            <Popper
                                {...popperProps}
                                style={{ ...style }} // width is passed in 'style' prop
                                className="assign-filter-content"
                            />
                        )}
                        disabled={!hasPermission() || !Utils.isEmptyString(props.ticketDetail?.deletedAt) || props?.isDisableAssign}
                        className={`assign-filter-text ${props.ticketDetail.id}`}
                        // freeSolo
                        multiple={true}
                        sx={{
                            maxHeight: 3
                        }}
                        options={listAssignee || []}
                        getOptionLabel={option => {
                            let optionLabel = option.fullName || '';
                            if (optionLabel && !Utils.isEmptyObject(option.affiliationOrganizationInfo) && Utils.getCorporationNameSuffixText(option.affiliationOrganizationInfo)) {
                                optionLabel = `${optionLabel} (${Utils.getCorporationNameSuffixText(option.affiliationOrganizationInfo)})`;
                            }
                            return optionLabel;
                        }}
                        getOptionSelected={(option, selectedValue) => {
                            return getOptionSelect(option, selectedValue)
                        }}
                        renderTags={valueTag => {
                            return valueTag.map((selectOption, index) => (
                                <Tooltip
                                    key={`assign-filter-tooltip-${selectOption.id}`}
                                    title={
                                        getTitle(selectOption)
                                    }
                                    className={
                                        selectOption.id === assigneeUserData[0]?.id
                                            ? 'assign-filter-tooltip active'
                                            : 'assign-filter-tooltip'
                                    }
                                    onClick={e => setOpen(true)}
                                >
                                    <span className="assign-option">
                                        {getSelectedOptionAvatar(selectOption)}
                                        <span className="assign-filter-name">
                                            {renderAssigneeName(selectOption)}
                                        </span>
                                    </span>
                                </Tooltip>
                            ));
                        }}
                        value={assigneeUserData}
                        filterOptions={filterSugguestionAssignOption}
                        disablePortal={true}
                        renderOption={option => (
                            <Tooltip
                                key={`assign-filter-tooltip-${option.id}`}
                                title={option.fullName}
                                className={
                                    option.id === assigneeUserData?.id
                                        ? 'option-item assign-filter-tooltip active'
                                        : 'option-item assign-filter-tooltip'
                                }
                            >
                                { option.fullName !== Constant.OPTION_UNASSIGNEE.TEXT ?
                                <span className="assign-option">
                                    {option.avatar && (
                                        <img
                                            src={option.avatar}
                                            alt=""
                                            className="assign-filter-avatar assign-filter-img"
                                        />
                                    )}
                                    {!option.avatar && (
                                        <span className="assign-filter-icon assign-filter-img">
                                            {Utils.getShortName(
                                                Utils.getTextByLanguage(
                                                    Constant.LANGUAGE_TYPE.JP,
                                                    option.lastName
                                                )
                                            )}
                                        </span>
                                    )}
                                    <span className="assign-filter-name">{getShortFullName(option.fullName,60)}</span>
                                </span> 
                                : 
                                <span className="assign-option">
                                    <span className="">{getShortFullName(option.fullName, 60)}</span>
                                </span> 
                                }
                            </Tooltip>
                        )}
                        // open
                        onChange={(e, newValue) => {
                            onSelectNewAssign(newValue);
                        }}
                        // noOptionsText={I18n.get('COMMSG001')}
                        renderInput={params => (
                            <RenderOptionTag params={params} assigneeUserData={assigneeUserData} />
                        )}
                    />
                    {props.isHelpDesk && Utils.isEmptyArray(props.assignList) && Utils.isEmptyObject(props.assigneeUserData) && (
                        <p style={{ marginTop: '10px' }}>{I18n.get('COMMSG001')}</p>
                    )}
                </div>
            </div>
        </div>
    );
};
export default AssigneeUI;
